import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import LoginReducer from "./auth/login/reducer";
import ProfileReducer from "./auth/profile/reducer";
import AccountReducer from "./auth/register/reducer";

import AuthReducer from "./auth/reducer";

import PaymentReducer from "./payment/reducer";

import ThemeReducer from "./theme/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  Auth: AuthReducer,
  Payment: PaymentReducer,
  Theme: ThemeReducer,
});

export default rootReducer;
